export default function HowItWorks() {
  const steps = [
    { num: '01', icon: 'ri-search-line', title: 'Find Products', desc: 'Browse our organized spreadsheet categories to discover trending products across shoes, clothing, accessories, and more.' },
    { num: '02', icon: 'ri-file-list-3-line', title: 'Compare Information', desc: 'Review product details, seller ratings, price ranges, and community feedback all in one structured view.' },
    { num: '03', icon: 'ri-zoom-in-line', title: 'Check QC Guidance', desc: 'Access quality check resources and learn how to verify product quality before confirming your purchase.' },
    { num: '04', icon: 'ri-shopping-cart-line', title: 'Complete Purchase', desc: 'Use your organized research to make confident purchasing decisions through Superbuy with full preparation.' },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900">
            How Superbuy Spreadsheet <span className="italic text-primary-600">Works</span>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-4 max-w-xl mx-auto">
            Four simple steps to transform your shopping experience with organized spreadsheet data.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {steps.map((step, idx) => (
            <div key={step.num} className="relative text-center">
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[60%] w-[80%] h-px bg-background-300"></div>
              )}
              <div className="w-16 h-16 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center text-primary-600 mb-5">
                <i className={`${step.icon} text-2xl`}></i>
              </div>
              <span className="text-xs font-bold text-primary-500 tracking-widest uppercase">{step.num}</span>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mt-2 mb-2">{step.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}